export interface Version {
    major: number;
    minor: number;
    patch: number;
}

export interface Definition {
    value: string;
    displayName: string;
}

export interface StateDefinitionType {
    defaultVersion: Version;
    definitions: Record<string, Definition>;
}